var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1513 6.43331L3.03459 30C2.74354 30.504 2.58953 31.0755 2.5879 31.6575C2.58627 32.2395 2.73707 32.8119 3.0253 33.3175C3.31353 33.8232 3.72913 34.2446 4.23077 34.5397C4.73241 34.8349 5.30259 34.9936 5.88459 35H34.1179C34.6999 34.9936 35.2701 34.8349 35.7717 34.5397C36.2734 34.2446 36.689 33.8232 36.9772 33.3175C37.2654 32.8119 37.4162 32.2395 37.4146 31.6575C37.413 31.0755 37.259 30.504 36.9679 30L22.8513 6.43331C22.5541 5.94349 22.1358 5.53851 21.6366 5.25745C21.1374 4.97639 20.5741 4.82874 20.0013 4.82874C19.4284 4.82874 18.8651 4.97639 18.3659 5.25745C17.8667 5.53851 17.4484 5.94349 17.1513 6.43331Z",
    fill: "#DF1D1D",
    stroke: "#373737",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15V21.6667",
    stroke: "#373737",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.3333H20.0172",
    stroke: "#373737",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleIcon);
export default __webpack_public_path__ + "static/media/alertTriangleIcon.a4231e7f60298131cfd191b366d2c69c.svg";
export { ForwardRef as ReactComponent };